import { NavigationMenuContent } from '@/components/NavigationMenu';
import { CtaLink } from '@/components/NewHeader/CtaLink';
import {
  CloseButton,
  DataList,
  PromotionalOffersList,
} from '@/components/NewHeader/NavBar/helperComponents';
import { useTranslation } from '@/contexts/dictionaryContext';
import useGTMEvents from '@/hooks/useGTMEvents';
import { usePromotionalCatalogs } from '@/hooks/usePromotionalCatalogs';

export function VillasInSicily() {
  const {
    newHeader: { villasInSicily, nav },
  } = useTranslation();
  const { sicily } = usePromotionalCatalogs();
  const promotionalCatalogs = sicily;

  const { sendMenuClickEvent } = useGTMEvents();

  const section =
    nav.find((item) => item.id === 'villas-in-sicily')?.title ||
    'Villas in Sicily';
  const offersTitle =
    nav.find((item) => item.id === 'offers')?.title || 'Offers';

  const handleItemClick = (item: { title: string; href: string }) =>
    sendMenuClickEvent({ section, sectionItem: item.title });

  return (
    <NavigationMenuContent className="w-full">
      <div className="grid grid-cols-2 gap-4">
        <div className="bg-black/5 py-12 pl-24 space-y-6">
          <p className="uppercase font-bold">
            {villasInSicily.byDestination.title}
          </p>
          <div className="grid grid-cols-2 gap-y-6">
            {villasInSicily.byDestination.items.map((list) => (
              <DataList
                onItemClick={handleItemClick}
                key={list.title}
                data={list}
              />
            ))}
          </div>
        </div>

        <div>
          <div className="py-12 pl-20 space-y-10 pr-8">
            <div className="grid grid-cols-2 gap-y-6">
              <DataList
                onItemClick={handleItemClick}
                data={villasInSicily.byArea}
                smallContainer
              />
              <div className="space-y-6">
                <DataList
                  onItemClick={handleItemClick}
                  data={villasInSicily.byType}
                  smallContainer
                />
                <PromotionalOffersList
                  title={offersTitle}
                  items={promotionalCatalogs}
                  onItemClick={handleItemClick}
                />
              </div>
            </div>

            <CtaLink
              onClick={() =>
                sendMenuClickEvent({
                  section,
                  sectionItem: villasInSicily.cta.title,
                })
              }
              href={villasInSicily.cta.href}
              className="w-fit">
              {villasInSicily.cta.title}
            </CtaLink>
          </div>

          <div className="pb-2">
            <CloseButton />
          </div>
        </div>
      </div>
    </NavigationMenuContent>
  );
}
